import React, { useState } from 'react';
import FormFields from '../../../Forms/FormFields';
import CommonFormFields from '../../../Forms/CommonFormFields';
import './UserPage3.css';
import HFRVerifyComponent from './HfrVerifyComponent/HFRVerifyComponent';
import {hfrVerify} from "../../../../constants"
interface formDataType {
  [key: string]: any;
}

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState3:any;
  handleFormChange3:(value: any, key: string, id: any, option: any, code: any)=>void;
  verify?:any
  facilityLocationId?:string,
  facilityLocationType?:string,
  healthFacilityNames?:any,
  hfrVerifyFormData?: any
};

const UserPage3 = ({hfrVerifyFormData,formData,formState3,handleFormChange3,verify,facilityLocationId,facilityLocationType,healthFacilityNames}: propsType) => {
  //const [hfrVerifyFormData,setHfrVerifyFormData]=useState<any>(hfrVerify);

  return (
    <div className="user_details_form_page3">
      <form className="form_container_user_details3 facility_details_wrapper">
        <HFRVerifyComponent formData={hfrVerifyFormData} actualFormData={formData} formState={formState3} handleFormChange={handleFormChange3} facilityLocationId={facilityLocationId} facilityLocationType={facilityLocationType} healthFacilityNames={healthFacilityNames} />
        <CommonFormFields
          formData={formData}
          formState={formState3}
          handleFormChange={handleFormChange3}
          verified={verify}
        />
      </form>
    </div>
  );
};
export default UserPage3;
